import { Injectable } from "@angular/core";
import { SeverityLevel } from "./severity-level.model";
import { AppConfigService } from "../../../../global-services/app-config.service";
import { environment } from 'apps/policy-admin/src/environments/environment';
@Injectable()
export class LoggingService {
   constructor(private appConfig: AppConfigService) { }

  // Log non-exception type errors, e.g. invalid API request
  logError(error: any) {
    this.log(error, SeverityLevel.Error);
  }

  logWarning(error: any) {
    this.log(error, SeverityLevel.Warning);
  }

  logInfo(error: any) {
    this.log(error, SeverityLevel.Information);
  }

  logVerbose(error: any) {
    this.log(error, SeverityLevel.Verbose);
  }

  logCritical(error: any) {
    this.log(error, SeverityLevel.Critical);
  }
  private log(error: any, severityLevel?: SeverityLevel) {
    /// Need to remove dependency of SeverityLevel
    if (
      environment.appConfig &&
      environment.appConfig.logging &&
      environment.appConfig.logging.console
    ) {
      this.sendToConsole(error, severityLevel);
    }
  } 

  private sendToConsole(
    error: any,
    severityLevel: SeverityLevel = SeverityLevel.Error
  ) {
    switch (severityLevel) {
      case SeverityLevel.Critical:
      case SeverityLevel.Error:
        (<any>console).group(environment.appConfig.appName + " Error: ");
        if (error.message) {
          console.error(error.message);
        } else if (error.stack) {
          console.error(error.stack);
        } else {
          console.error(error);
        }
        (<any>console).groupEnd();
        break;
      case SeverityLevel.Warning:
        (<any>console).group(environment.appConfig.appName + " Error: ");
        console.warn(error);
        (<any>console).groupEnd();
        break;
      case SeverityLevel.Information:
        (<any>console).group(environment.appConfig.appName + " Error: ");
        console.log(error);
        (<any>console).groupEnd();
        break;
    }
  }
}
